import React, { Fragment, useState } from "react";
import ModalVideo from "react-modal-video";
import Header2 from "../../components/header/Header2";
import Scrollbar from "../../components/WhatsAppBtn/WhatsAppBtn";
import Footer from "../../components/footer/Footer";
import CtaSection from "../../components/CtaSection/CtaSection";
import Bg from "../../images/bg/page_bg01.jpg";
import icon from "../../images/icon/ser-01.svg";
import vImg from "../../images/video/img03.jpg";
import vImg2 from "../../images/video/polygon02.png";
import sImg1 from "../../images/icon/sd-icon01.svg";
import sImg2 from "../../images/icon/sd-icon02.svg";
import sImg3 from "../../images/icon/sd-icon03.svg";
import sImg4 from "../../images/icon/sd-icon04.svg";
import shape from "../../images/shape/sd-shape.png";
import sicon from "../../images/icon/check-icon.svg";
import bannerDatacenerVirtual from "../../images/banners/banners_datacenter_virtual.png";

const DatacenterVirtualPage = (props) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <Fragment>
      <div className="sco_agency">
        <Header2 />
        <main className="page_content service-single-page">
          <section
            className="page-title pt-200 pos-rel bg_img"
            style={{ backgroundImage: `url(${Bg})` }}
          >
            <div className="container">
              <div className="page-title-wrap sd-title-wrap">
                <div className="row mt-none-30 align-items-center justify-content-center">
                  <div className="col-lg-10 col-xl-8 mt-30">
                    <div className="page-title-box">
                      <span className="sub-title">
                        <img src={icon} alt="" /> Datacenter Virtual
                      </span>
                      <h2 className="title">
                        Sua infraestrutura completa <br /> na nuvem com controle{" "}
                        <br /> total e segurança máxima
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="video pt-70 pb-65">
            <div className="container">
              <div className="xb-video sd-video image-only pos-rel">
                <img src={bannerDatacenerVirtual} alt="Data Center Virtual" />
              </div>
            </div>
          </div>
          <div className="sd-ser-content_wrap pb-110">
            <div className="container">
              <div className="sd-ser-content">
                <h2 className="sd-title">
                  Datacenter Virtual Somar: Sua Empresa na Nuvem
                </h2>
                <p className="sd-content">
                  O Datacenter Virtual da Somar Cloud oferece uma solução
                  completa de infraestrutura como serviço (IaaS), permitindo que
                  sua empresa tenha um datacenter privado totalmente
                  virtualizado sem os investimentos e complexidades de manter
                  infraestrutura física própria. Nossa solução integra
                  servidores, storage, rede e segurança em uma plataforma
                  unificada e altamente escalável.
                </p>
                <br />
                <p className="sd-content">
                  Com storage all-flash de última geração e infraestrutura
                  redundante, oferecemos performance empresarial com a
                  flexibilidade da nuvem. Nossos datacenters virtuais incluem
                  redes privadas isoladas, firewalls dedicados, load balancers,
                  e sistemas de backup automatizados, proporcionando uma
                  experiência idêntica a um datacenter físico, mas com toda a
                  agilidade e economia da virtualização.
                </p>
                <br />
                <p className="sd-content">
                  <strong>Exclusividades Somar Cloud:</strong> Orquestração
                  inteligente de recursos, auto-scaling baseado em IA, disaster
                  recovery multi-site, compliance automático com normas
                  brasileiras, e portal self-service para gestão completa.
                  Elimine 100% dos CAPEX de infraestrutura mantendo controle
                  total sobre seus recursos.
                </p>
              </div>
            </div>
          </div>
          <div className="sd-process_warp">
            <div className="container">
              <div className="sd-heading">
                <h2 className="sd-title">Metodologia de Virtualização</h2>
                <p className="sd-content">
                  Nossa abordagem estruturada garante migração completa e segura
                  de sua infraestrutura para um ambiente virtualizado otimizado
                  e altamente disponível.
                </p>
              </div>
              <div className="sd-process_inner ul_li">
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg1} alt="" />
                  </div>
                  <h3 className="xb-item--title">Discovery e Mapping</h3>
                  <p className="xb-item--contact">
                    Mapeamento completo da infraestrutura atual e dependências.
                  </p>
                  <span className="xb-item--number">01</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg2} alt="" />
                  </div>
                  <h3 className="xb-item--title">Design Virtualizado</h3>
                  <p className="xb-item--contact">
                    Arquitetura de datacenter virtual otimizada para
                    performance.
                  </p>
                  <span className="xb-item--number">02</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg3} alt="" />
                  </div>
                  <h3 className="xb-item--title">Migração Orquestrada</h3>
                  <p className="xb-item--contact">
                    Transferência coordenada com zero impacto nas operações.
                  </p>
                  <span className="xb-item--number">03</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg4} alt="" />
                  </div>
                  <h3 className="xb-item--title">Operação Gerenciada</h3>
                  <p className="xb-item--contact">
                    Gestão proativa com SLA enterprise e suporte dedicado.
                  </p>
                  <span className="xb-item--number">04</span>
                </div>
                <div className="sd-shape">
                  <img src={shape} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="sd-service_wrap pt-115 pb-130">
            <div className="container">
              <div className="sd-ser-outcome">
                <div className="sd-heading">
                  <h2 className="sd-title">Benefícios do Datacenter Virtual</h2>
                  <p className="sd-content">
                    Transforme sua infraestrutura de TI em um ativo estratégico
                    ágil e econômico, eliminando complexidades operacionais e
                    maximizando eficiência.
                  </p>
                </div>
                <div className="sd-list-item ul_li">
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      Redução de 70% nos custos de infraestrutura
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Elasticidade automática de recursos
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Disaster recovery integrado multi-site
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Portal self-service para gestão completa
                    </li>
                  </ul>
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      Virtualização enterprise de nível corporativo
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Storage all-flash de alta performance
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Redes privadas isoladas e seguras
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Compliance automático com LGPD
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </main>
        <CtaSection />
      </div>
      <Footer />
      <Scrollbar />
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="7e90gBu4pas"
        onClose={() => setOpen(false)}
      />
    </Fragment>
  );
};

export default DatacenterVirtualPage;
